import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-gray-50" data-id="element-85">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2317a2b8' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} data-id="element-86" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-87">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-88">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl relative" data-id="element-89">
            {/* Background Logo - Watermark Style */}
            <div className="absolute -left-[250px] -top-[150px] w-[900px] h-[900px] -z-10 opacity-[0.07] pointer-events-none select-none rotate-[-12deg] grayscale mix-blend-multiply" data-id="element-90">
              <img src="https://cdn.magicpatterns.com/uploads/r2Qpm7TVH9yfhMg7exMXJN/IMG_2424.png" alt="" className="w-full h-full object-contain" data-id="element-91" />
            </div>

            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#17a2b8]/10 text-[#17a2b8] text-sm font-semibold mb-6" data-id="element-92">
              <span className="relative flex h-2 w-2" data-id="element-93">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#17a2b8] opacity-75" data-id="element-94"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#17a2b8]" data-id="element-95"></span>
              </span>
              Serving Portland Metro Area
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 tracking-tight" data-id="element-96">
              <span className="text-[#17a2b8]" data-id="element-97">Your Home,</span> <br data-id="element-98" />
              <span className="text-[#2c2c2c]" data-id="element-99">Fixed & Finished.</span>
            </h1>

            <p className="text-lg sm:text-xl text-[#525252] mb-8 leading-relaxed max-w-lg" data-id="element-100">
              Portland's reliable partner for maintenance, repairs, and small
              remodels. We show up on time and get the job done right.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-101">
              <Button variant="primary" size="lg" rightIcon={<ArrowRight className="h-5 w-5" data-id="element-103" />} onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-102">
                Request Service
              </Button>
              <Button variant="outline" size="lg" onClick={() => document.getElementById('services')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-104">
                View Services
              </Button>
            </div>

            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-medium text-[#525252]" data-id="element-105">
              {['Licensed & Insured', 'Free Estimates', 'Locally Owned'].map(item => <div key={item} className="flex items-center gap-2" data-id="element-106">
                    <CheckCircle2 className="h-4 w-4 text-[#17a2b8]" data-id="element-107" />
                    {item}
                  </div>)}
            </div>
          </motion.div>

          {/* Visual/Image Area */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-108">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white aspect-square border-8 border-white" data-id="element-109">
              <video className="w-full h-full object-cover" autoPlay loop muted playsInline src="https://cdn.magicpatterns.com/uploads/4mp5uW4W7dmjasaMcMLdnR/FF_-_website_1.1_1.undefined" data-id="element-110" />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#ff6b35] rounded-full opacity-20 blur-2xl" data-id="element-111"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#17a2b8] rounded-full opacity-20 blur-2xl" data-id="element-112"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}